import { render, staticRenderFns } from "./LoginAggr.vue?vue&type=template&id=21b36f6a&scoped=true"
import script from "./LoginAggr.vue?vue&type=script&lang=js"
export * from "./LoginAggr.vue?vue&type=script&lang=js"
import style0 from "./LoginAggr.vue?vue&type=style&index=0&id=21b36f6a&prod&lang=less&scoped=true"
import style1 from "./LoginAggr.vue?vue&type=style&index=1&id=21b36f6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b36f6a",
  null
  
)

export default component.exports